import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from './firebaseSetup';
import { PagebuilderContactFormSubmission } from './models/pagebuilderContactFormSubmission';
import { Logger } from './utils/logger';
import { getRecommendationIdFromUrl } from './getDocument';
import { RecommendationTracker } from './utils/recommendationTracking';

export async function sendContactForm(model: PagebuilderContactFormSubmission) {
    const functions = getFunctions(app, 'europe-west3');
    const callable = httpsCallable(functions, 'pagebuilderContactFormSubmission');

    const sanitizedData = Object.fromEntries(
        Object.entries(model.toMap()).filter(([_, v]) => v !== undefined && v !== '')
    );

    Logger.info('📤 Formular-Daten werden gesendet');
    Logger.debug('🧼 Bereinigte Daten:', sanitizedData);

    try {
        const result = await callable(sanitizedData);
        Logger.info('📨 Antwort von Firebase erhalten', result.data);
        const recommendationId = getRecommendationIdFromUrl();
        if (recommendationId) {
            await RecommendationTracker.trackRecommendation("contactFormSent", recommendationId);
        }
        return result.data;
    } catch (error) {
        Logger.error('❌ Fehler beim Senden der Nachricht', error);
        const msg = error instanceof Error ? error.message : 'Unbekannter Fehler';
        throw new Error(`Fehler beim Senden: ${msg}`);
    }
}
